import { render, staticRenderFns } from "./KnFormStudent.vue?vue&type=template&id=79f1ee70&"
import script from "./KnFormStudent.vue?vue&type=script&lang=js&"
export * from "./KnFormStudent.vue?vue&type=script&lang=js&"
import style0 from "./KnFormStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports